import React from "react";
import {
  CheckboxInput,
  DateInput,
  RadioInput,
  TextInput,
} from "../../../components/input_hook_form";
import "./style.scss";

const manualOptions = [
  { value: 1, label: "Manual", name: "morningstar-manual" },
];
const ratingOptions = [
  { value: "", label: "Not rated" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

function Morningstar(props) {
  const {
    register,
    show,
    mode,
    control,
    errors,
    defaultValues,
    setValue,
    getValues,
    watch,
    morningstar,
  } = props;
  const locked = mode === "VIEW" || !watch("morningstar-manual");

  return (
    <div className={show ? "morningstar-container" : "morningstar-container-hide"}>
      <CheckboxInput
        label={"Override"}
        options={manualOptions}
        register={register}
        disabled={mode === "VIEW"}
      />
      <p className={"morningstar-note"}>
        While ticked, the NAV sync does not overwrite Rating, Category and
        Rating Date.
      </p>
      {morningstar && morningstar.updated_by ? (
        <p className={"morningstar-note"}>
          {morningstar.manual ? "Overridden" : "Released"} by{" "}
          {morningstar.updated_by} on {morningstar.updated_at}
        </p>
      ) : null}
      <div className={"morningstar-spacer"} />
      <RadioInput
        label={"Rating"}
        name="morningstar-rating"
        options={ratingOptions}
        control={control}
        disabled={locked}
      />
      <p className={"morningstar-note"}>
        The app shows 4 and 5 star ratings only.
      </p>
      <div className={"morningstar-spacer"} />
      <TextInput
        label={"Category"}
        placeholder={"Category"}
        error={!locked && errors["morningstar-category"]}
        register={register({
          validate: (value) =>
            !getValues("morningstar-manual") || value.trim().length <= 100,
        })}
        type={"text"}
        name="morningstar-category"
        disabled={locked}
      />
      <div className={"morningstar-spacer"} />
      <DateInput
        label={"Rating Date (DD-MM-YYYY)"}
        placeholder={"Rating Date (DD-MM-YYYY)"}
        control={control}
        setValue={setValue}
        rules={{ required: false }}
        name="morningstar-ratingdate"
        disabled={locked}
        defaultValues={defaultValues["morningstar-ratingdate"]}
      />
    </div>
  );
}

export default Morningstar;
